import React, { useState } from "react";

export default function HistoryAndDetails({
  historyItems,
  onUseHistory,
  onDelete,
}) {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleExpand = (idx) => {
    setExpandedIndex(expandedIndex === idx ? null : idx);
  };

  return (
    <div className="bg-base-100 rounded-lg border p-4 shadow-sm flex flex-col h-full">
      <h2 className="mb-3 text-lg font-semibold">History & Search Details</h2>

      {historyItems.length === 0 ? (
        <p className="text-gray-500">Your search history is empty.</p>
      ) : (
        <div className="h-[calc(100%-120px)] overflow-auto">
          <table className="table table-zebra w-full">
            <thead className="sticky top-0 bg-base-100 z-10">
              <tr>
                <th className="w-12">#</th>
                <th>Query</th>
                <th>Estimated Result Count</th>
                <th className="w-56">Timestamp</th>
              </tr>
            </thead>

            <tbody>
              {historyItems.map((item, idx) => (
                <tr key={idx}>
                  <td>{idx + 1}</td>
                  <td className="max-w-xs truncate">{item.query}</td>
                  <td className="font-mono">{item.resultCount?.toLocaleString() ?? "—"}</td>
                  <td className="text-xs text-gray-500">
                    {item.timestamp ? new Date(item.timestamp).toLocaleString() : "—"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );

}
